import { render } from "./PencilIcon.vue?vue&type=template&id=374870ba&scoped=true"
const script = {}

import "./PencilIcon.vue?vue&type=style&index=0&id=374870ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374870ba"]])

export default __exports__